export interface ComputersAndVmResponse {
  success: boolean;
  data: Array<ComputersAndVmItem>;
  total: number;
}

export interface ComputersAndVmRowDataGrid {
  item: ComputersAndVmItem;
}

export interface ComputersAndVmItem {
  _id: string;
  size?: number;
  recordSource: number;
  quarantinedDate: string;
  actionStatus: number;
  threats: Threats;
  source: Source;
  module?: number;
  isGhost?: boolean;
  archiveSpecifics?: ArchiveSpecifics;
  canSubmitToSandbox?: boolean;
}

export interface Source {
  endpointId: string;
  protectedEntity: ProtectedEntity;
  filePath: string;
  fileId: string;
  company: Company;
}

export interface ArchiveSpecifics {
  archiveName?: string;
  fileId: string;
  url: string;
  expiresAt: string;
  submittedToLabs?: number;
}

export interface Company {
  id: string;
  name: string;
}

export interface ProtectedEntity {
  eps: Eps;
  sve: Sve;
  name: string;
  ip: string;
}

export interface Sve {
  id?: any;
  name?: any;
  type?: any;
  svaId?: any;
  sveMultiPlatform?: boolean;
  unsynced?: boolean;
}

export interface Eps {
  id: string;
  name: string;
  type: number;
}

export interface Threats {
  type: number;
  name: string;
}

export interface RestoreQuarantinePayload {
  records: Array<any>;
  restoreType: number;
  restorePath: string;
  addExclusion: boolean;
  edr: string | null;
}

export interface RestoreQuarantineResponse {
  data: Array<ComputersAndVmItem>;
  success: boolean;
  total: number;
}

export interface DeleteSelectedPayload {
  records: Array<ComputersAndVmItem>;
}

export interface DeleteSelectedResponse {
  nbOfCreatedTasks: number;
  success: boolean;
}

export interface EmptyQuarantinePayload {
  includeSubCompanies: boolean;
}

export interface ValidateRetrievePayload {
  endpointId: string;
}

export interface AddExclusionResponse {
  success: boolean;
  data: Array<string>;
}

export enum QuarantineEndpointMethod {
  READ_RECORDS = 'readRecords',
  CREATE_RESTORE_TASK = 'createRestoreTask',
  CREATE_REMOVE_TASK = 'createRemoveTask',
  CREATE_REMOVE_ALL_TASK = 'createRemoveAllTask',
  VALIDATE_RETRIEVE_ACTION = 'validateRetrieveAction',
  RETRIEVE_QUARANTINE_FILE = 'retrieveQuarantineFile',
  DELETE_RETRIEVED_QUARANTINE_FILE = 'deleteRetrievedQuarantineFile',
  SUBMIT_TO_LABS = 'submitToLabs',
}

export enum QuarantineFilesMethod {
  VALIDATE_RETRIEVED_FILE = 'validateRetrievedFile',
}

export enum ExclusionItemsMethods {
  CREATE_RECORDS = 'createRecords',
}

export interface DownloadSelectedResponse {
  fileName: string;
  response: Blob;
}

export interface RetrieveQuarantineFilePayload {
  records: Array<any>;
  archiveName: string;
  archivePassword: string;
}

export interface DeleteRetrieveQuarantineFilePayload {
  quarantineId: string;
}

export interface ValidateQuarantineFilePayload {
  fileId: string;
}

export interface RetrieveQuarantineFileResponse {
  success: boolean;
}

export interface DeleteRetrieveQuarantineFileResponse {
  success: boolean;
}

export interface SubmitToLabsDialogContent {
  product: {
    title: string;
    value: number;
  }[];
  fullName: string;
  email: string;
  filename: string;
}

export interface SubmitToLabsFilePayload {
  productId: number;
  fullName: string;
  email: string;
  quarantineId: string;
  password: string;
  sensitiveFiles: boolean;
}
